<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">Slider</h2>

    <v-card outlined class="px-3 py-3">
      <v-tabs v-model="tab" show-arrows @change="selectTab">
        <v-tab class="text-caption font-weight-bold">Semua</v-tab>
        <v-tab class="text-caption font-weight-bold">Aktif</v-tab>
        <v-tab class="text-caption font-weight-bold">Draft</v-tab>

        <v-tab-item>
          <sliderData type="all" v-if="tab == 0"></sliderData>
        </v-tab-item>

        <v-tab-item>
          <sliderData type="active" v-if="tab == 1"></sliderData>
        </v-tab-item>

        <v-tab-item>
          <sliderData type="inactive" v-if="tab == 2"></sliderData>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import sliderData from "./components/all";
// import produkLive from './components/produkLive'
// import produkSold from './components/produkSold'
// import produkArchived from './components/produkArchived'

export default {
  components: {
    sliderData
    // produkLive, produkSold, produkArchived
  },
  data() {
    return {
      tab: 1
    };
  },
  methods: {
    // ...mapActions("category", ["getCategory"]),

    selectTab(val) {
      this.tab = val;
    }
  },
  created() {
    // this.getCategory();
  },
  mounted() {
    let tab = this.$route.query.type
    if (tab == 'active') this.tab = 1
    if (tab == 'inactive') this.tab = 2
  }
};
</script>